/**
 * created by li si yi
 * 筛选组件
 */
import React, {Component} from 'react';
import {Button} from "antd";
import BaseComponent from "../../../../base/BaseComponent";
import moment from "moment";
import DeptSelect from "./DeptSelect";
import MediaSelect from "./MediaSelect";

class Screen extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            mediaList: []
        }
    }

    componentDidMount() {
    }

    componentWillReceiveProps(nextProps, nextContext) {
        // console.log(nextProps, nextContext);
        // this.state.dataSource = nextProps.chartsData;
        // this.setState({
        //     dataSource: nextProps.chartsData
        // })
    }

    getMediaList = (res) => {
        this.mediaSelect.getMediaList(res);
    };

    render() {
        let {deptList} = this.state;
        // console.log(this.props?.deptList);
        // debugger
        return (
            <div style={{display: 'flex', marginBottom: '20px'}} className={'query_style'}>
                {
                    this.props?.otherParams?.showDeptSelect ?
                        <DeptSelect
                            ref={ref => this.deptSelect = ref}
                            deptList={this.props?.deptList}
                            checkDept={this.props?.checkDept}
                            resetDept={this.props?.resetDept}
                            maxTagCount={1}
                        />
                        : null
                }
                <MediaSelect
                    ref={ref => this.mediaSelect = ref}
                    mediaList={this.props.mediaList}
                    checkMedia={this.props.checkMedia}
                    resetMedia={this.props?.resetMedia}
                    maxTagCount={1}
                />
                <Button type={"primary"} style={{marginRight: 20}} onClick={() => {
                    this.props.onQueryCall && this.props.onQueryCall()
                }}>查询</Button>
                <Button className={'resetting'} style={{marginRight: 20}} onClick={() => {
                    this.setState({}, () => {
                        this.props.onRefreshCall && this.props.onRefreshCall();
                    });
                }}>重置</Button>
                <style>{`
                 .query_style .resetting{
                    color:#000 !important;
                 }
                `}</style>
            </div>
        );
    };
}

export default Screen;